var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { attrs: { inline: false, "label-position": "top", size: "small" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 7 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "timeType" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c(
                          "div",
                          { staticClass: "selectLabel" },
                          [
                            _c(
                              "el-select",
                              {
                                style: _vm.IsWidth,
                                model: {
                                  value: _vm.queryForm.params.timeType,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "timeType",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.timeType",
                                },
                              },
                              [
                                _c("el-option", {
                                  key: "1",
                                  attrs: {
                                    label: _vm.$t("GlobalSetObj.CreationTime"),
                                    value: 1,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: false,
                          "default-time": ["00:00:00", "23:59:59"],
                          "end-placeholder": _vm.$t("GlobalSetObj.endDate"),
                          format:
                            _vm.$i18n.locale == "zh" ? _vm.zhDate : _vm.ptDate,
                          "start-placeholder": _vm.$t("GlobalSetObj.startDate"),
                          "range-separator": "~",
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                        },
                        model: {
                          value: _vm.timeValue,
                          callback: function ($$v) {
                            _vm.timeValue = $$v
                          },
                          expression: "timeValue",
                        },
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.status") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                          },
                          model: {
                            value: _vm.queryForm.params.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "status", $$v)
                            },
                            expression: "queryForm.params.status",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.all"),
                              value: null,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.enable"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.stop"),
                              value: 0,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("collectionCenter.stateSite1") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            filterable: "",
                            size: "small",
                          },
                          model: {
                            value: _vm.queryForm.params.siteState,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "siteState", $$v)
                            },
                            expression: "queryForm.params.siteState",
                          },
                        },
                        _vm._l(_vm.stateList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.label, value: item.label },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("navbar.cityType") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            size: "small",
                          },
                          model: {
                            value: _vm.queryForm.params.areaType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm.params, "areaType", $$v)
                            },
                            expression: "queryForm.params.areaType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "州府(CAPITAL)", value: 1 },
                          }),
                          _c("el-option", {
                            attrs: { label: "市区(METROPOLITAN)", value: 2 },
                          }),
                          _c("el-option", {
                            attrs: { label: "农村(COUNTRYSIDE)", value: 3 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("collectionCenter.timelinessStartState"),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            size: "small",
                          },
                          model: {
                            value: _vm.queryForm.params.agingStartState,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "agingStartState",
                                $$v
                              )
                            },
                            expression: "queryForm.params.agingStartState",
                          },
                        },
                        _vm._l(_vm.stateList, function (item1) {
                          return _c("el-option", {
                            key: item1.id,
                            attrs: { label: item1.label, value: item1.label },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 15 } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-search",
                        size: "small",
                        type: "primary",
                      },
                      on: { click: _vm.enterSearch },
                    },
                    [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-refresh-left",
                        size: "small",
                        type: "info",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.resetForm()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-bottom": "15px" },
                      attrs: { size: "small", type: "primary" },
                      on: { click: _vm.addCusTime },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("uploadFile.addInternalLeadTime")) + " "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.openBulkImport },
                    },
                    [_vm._v(_vm._s(_vm.$t("basicData.BulkImport")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            border: "",
            "max-height": "600",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serial"),
              align: "center",
              type: "index",
              width: "70",
            },
          }),
          _vm._l(_vm.tableHeaderList, function (item) {
            return _c("el-table-column", {
              key: item.id,
              attrs: {
                label: item.label,
                "min-width": item.cloWidth,
                prop: item.prop,
                "show-overflow-tooltip": false,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "merchantName" &&
                        scope.row.merchantName &&
                        scope.row.merchantCode
                          ? _c("div", [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.merchantName) +
                                    "（" +
                                    _vm._s(scope.row.merchantCode) +
                                    "） "
                                ),
                              ]),
                            ])
                          : item.prop === "statusTypeObjName"
                          ? _c(
                              "div",
                              [
                                scope.row.status === 0
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          size: "small",
                                          type: "danger",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.statusTypeObjName) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          size: "small",
                                          type: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(scope.row.statusTypeObjName) +
                                            " "
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            )
                          : item.prop === "slaVersion"
                          ? _c("div", [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    scope.row.slaVersionDisplay ||
                                      (scope.row.slaVersion
                                        ? "V" +
                                          Number(scope.row.slaVersion).toFixed(
                                            1
                                          )
                                        : "- -")
                                  )
                                ),
                              ]),
                            ])
                          : _c("div", [
                              _vm._v(
                                _vm._s(
                                  scope.row[item.prop]
                                    ? "" + scope.row[item.prop]
                                    : "- -"
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("newOrder.operation"),
              align: "center",
              fixed: "right",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-around",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t(
                                "customerManagements.viewVersionHistory"
                              ),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-time textOperator",
                              on: {
                                click: function ($event) {
                                  return _vm.viewVersionHistory(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: _vm.$t("GlobalSetObj.edit"),
                              effect: "dark",
                              placement: "top",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-edit textOperator",
                              on: {
                                click: function ($event) {
                                  return _vm.editMessage(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        scope.row.status === 0
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  content: _vm.$t("GlobalSetObj.enable"),
                                  effect: "dark",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-circle-check textOperator",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateStatus(scope.row)
                                    },
                                  },
                                }),
                              ]
                            )
                          : _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  content: _vm.$t("GlobalSetObj.stop"),
                                  effect: "dark",
                                  placement: "top",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-remove-outline textOperator1",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateStatus(scope.row)
                                    },
                                  },
                                }),
                              ]
                            ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _c("el-pagination", {
        staticStyle: { margin: "10px 0", float: "right" },
        attrs: {
          "current-page": _vm.queryForm.pageNumber,
          "page-size": _vm.queryForm.pageSize,
          "page-sizes": [10, 20, 50, 100],
          total: _vm.queryForm.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-class",
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.cusTimeDialogTitle,
            visible: _vm.addCusTimeDialog,
            width: "550px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addCusTimeDialog = $event
            },
            close: _vm.handleAddCusTimeDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleRef",
              staticClass: "rule-box-class",
              attrs: { model: _vm.ruleForm },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: {
                    "justify-content": "space-between",
                    "flex-wrap": "wrap",
                    margin: "20px 20px 0 20px",
                  },
                  attrs: { type: "flex" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.stateSite1"),
                            prop: "siteState",
                            rules: {
                              required: true,
                              message: _vm.$t("collectionCenter.notNull"),
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.ruleForm.siteState,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "siteState", $$v)
                                },
                                expression: "ruleForm.siteState",
                              },
                            },
                            _vm._l(_vm.stateList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.label, value: item.label },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "customerManagements.timeframeStartingPointName"
                            ),
                            prop: "agingStartType",
                            rules: {
                              required: true,
                              message: _vm.$t("collectionCenter.notNull"),
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.OnlyAreDisplayed"
                                ),
                                clearable: "",
                                size: "small",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.clearCode("")
                                },
                              },
                              model: {
                                value: _vm.ruleForm.agingStartType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "agingStartType", $$v)
                                },
                                expression: "ruleForm.agingStartType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("newOrder.StorageTimeOutlets"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "collectionCenter.secondaryOrTertiaryArrivalTime"
                                  ),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.ruleForm.agingStartType !== 1
                    ? _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "collectionCenter.timelinessStartState"
                                ),
                                prop: "agingStartState",
                                rules: {
                                  required: true,
                                  message: _vm.$t("collectionCenter.notNull"),
                                  trigger: ["blur", "change"],
                                },
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.ruleForm.agingStartState,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "agingStartState",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.agingStartState",
                                  },
                                },
                                _vm._l(_vm.stateList, function (item1) {
                                  return _c("el-option", {
                                    key: item1.id,
                                    attrs: {
                                      label: item1.label,
                                      value: item1.label,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.ruleForm.agingStartType !== 1
                    ? _c(
                        "el-col",
                        { attrs: { span: 11 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "collectionCenter.timelinessCalculationMode"
                                ),
                                prop: "agingCalculationMode",
                                rules: {
                                  required: true,
                                  message: _vm.$t("collectionCenter.notNull"),
                                  trigger: ["blur", "change"],
                                },
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.ruleForm.agingCalculationMode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "agingCalculationMode",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.agingCalculationMode",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "collectionCenter.earliestArrivalTime"
                                      ),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "collectionCenter.latestArrivalTime"
                                      ),
                                      value: 2,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("navbar.cityType"),
                            prop: "areaType",
                            rules: {
                              required: true,
                              message: _vm.$t("collectionCenter.notNull"),
                              trigger: ["blur", "change"],
                            },
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                size: "small",
                              },
                              model: {
                                value: _vm.ruleForm.areaType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "areaType", $$v)
                                },
                                expression: "ruleForm.areaType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "州府(CAPITAL)", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: "市区(METROPOLITAN)",
                                  value: 2,
                                },
                              }),
                              _c("el-option", {
                                attrs: { label: "农村(COUNTRYSIDE)", value: 3 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("uploadFile.leadTimeHours"),
                            prop: "duration",
                            rules: [
                              {
                                required: true,
                                message: _vm.$t("collectionCenter.notNull"),
                                trigger: ["blur", "change"],
                              },
                              {
                                pattern: /^[1-9]\d{0,9}$/,
                                message: _vm.$t("collectionCenter.inputNum"),
                                trigger: ["blur", "change"],
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "collectionCenter.pleaseInput"
                              ),
                              size: "small",
                              clearable: "",
                              maxlength: "10",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.ruleForm.duration,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "duration", $$v)
                              },
                              expression: "ruleForm.duration",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.cusTimeDialogTitle ===
              _vm.$t("uploadFile.addInternalLeadTime")
                ? _c(
                    "div",
                    _vm._l(_vm.ruleForm.ruleForm2, function (item, index) {
                      return _c(
                        "el-row",
                        {
                          key: index,
                          staticClass: "row-box-class",
                          attrs: { type: "flex" },
                        },
                        [
                          _c("div", {
                            staticClass: "el-icon-close closeBtn",
                            on: {
                              click: function ($event) {
                                return _vm.removeRow(index)
                              },
                            },
                          }),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.stateSite1"
                                    ),
                                    prop: "ruleForm2." + index + ".siteState",
                                    rules: {
                                      required: true,
                                      message: _vm.$t(
                                        "collectionCenter.notNull"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.OnlyAreDisplayed"
                                        ),
                                        clearable: "",
                                        filterable: "",
                                        size: "small",
                                      },
                                      model: {
                                        value: item.siteState,
                                        callback: function ($$v) {
                                          _vm.$set(item, "siteState", $$v)
                                        },
                                        expression: "item.siteState",
                                      },
                                    },
                                    _vm._l(_vm.stateList, function (item1) {
                                      return _c("el-option", {
                                        key: item1.id,
                                        attrs: {
                                          label: item1.label,
                                          value: item1.label,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "customerManagements.timeframeStartingPointName"
                                    ),
                                    prop:
                                      "ruleForm2." + index + ".agingStartType",
                                    rules: {
                                      required: true,
                                      message: _vm.$t(
                                        "collectionCenter.notNull"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.OnlyAreDisplayed"
                                        ),
                                        clearable: "",
                                        size: "small",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.clearCode(index)
                                        },
                                      },
                                      model: {
                                        value: item.agingStartType,
                                        callback: function ($$v) {
                                          _vm.$set(item, "agingStartType", $$v)
                                        },
                                        expression: "item.agingStartType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "newOrder.StorageTimeOutlets"
                                          ),
                                          value: 1,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "collectionCenter.secondaryOrTertiaryArrivalTime"
                                          ),
                                          value: 2,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          item.agingStartType !== 1
                            ? _c(
                                "el-col",
                                { attrs: { span: 11 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "collectionCenter.timelinessStartState"
                                        ),
                                        prop:
                                          "ruleForm2." +
                                          index +
                                          ".agingStartState",
                                        rules: {
                                          required: true,
                                          message: _vm.$t(
                                            "collectionCenter.notNull"
                                          ),
                                          trigger: ["blur", "change"],
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "GlobalSetObj.pleaseChoose"
                                            ),
                                            clearable: "",
                                            size: "small",
                                          },
                                          model: {
                                            value: item.agingStartState,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "agingStartState",
                                                $$v
                                              )
                                            },
                                            expression: "item.agingStartState",
                                          },
                                        },
                                        _vm._l(_vm.stateList, function (item1) {
                                          return _c("el-option", {
                                            key: item1.id,
                                            attrs: {
                                              label: item1.label,
                                              value: item1.label,
                                            },
                                          })
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          item.agingStartType !== 1
                            ? _c(
                                "el-col",
                                { attrs: { span: 11 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "collectionCenter.timelinessCalculationMode"
                                        ),
                                        prop:
                                          "ruleForm2." +
                                          index +
                                          ".agingCalculationMode",
                                        rules: {
                                          required: true,
                                          message: _vm.$t(
                                            "collectionCenter.notNull"
                                          ),
                                          trigger: ["blur", "change"],
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "GlobalSetObj.pleaseChoose"
                                            ),
                                            clearable: "",
                                            size: "small",
                                          },
                                          model: {
                                            value: item.agingCalculationMode,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "agingCalculationMode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.agingCalculationMode",
                                          },
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "collectionCenter.earliestArrivalTime"
                                              ),
                                              value: 1,
                                            },
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "collectionCenter.latestArrivalTime"
                                              ),
                                              value: 2,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("navbar.cityType"),
                                    prop: "ruleForm2." + index + ".areaType",
                                    rules: {
                                      required: true,
                                      message: _vm.$t(
                                        "collectionCenter.notNull"
                                      ),
                                      trigger: ["blur", "change"],
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                        clearable: "",
                                        size: "small",
                                      },
                                      model: {
                                        value: item.areaType,
                                        callback: function ($$v) {
                                          _vm.$set(item, "areaType", $$v)
                                        },
                                        expression: "item.areaType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "州府(CAPITAL)",
                                          value: 1,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "市区(METROPOLITAN)",
                                          value: 2,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "农村(COUNTRYSIDE)",
                                          value: 3,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("uploadFile.leadTimeHours"),
                                    prop: "ruleForm2." + index + ".duration",
                                    rules: [
                                      {
                                        required: true,
                                        message: _vm.$t(
                                          "collectionCenter.notNull"
                                        ),
                                        trigger: ["blur", "change"],
                                      },
                                      {
                                        pattern: /^[1-9]\d{0,9}$/,
                                        message: _vm.$t(
                                          "collectionCenter.inputNum"
                                        ),
                                        trigger: ["blur", "change"],
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "collectionCenter.pleaseInput"
                                      ),
                                      size: "small",
                                      clearable: "",
                                      maxlength: "10",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: item.duration,
                                      callback: function ($$v) {
                                        _vm.$set(item, "duration", $$v)
                                      },
                                      expression: "item.duration",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer footer-stick-class",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.cusTimeDialogTitle ===
              _vm.$t("uploadFile.addInternalLeadTime")
                ? _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.addList } },
                    [_vm._v(_vm._s(_vm.$t("GlobalSetObj.append")))]
                  )
                : _c("span"),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.cusSubmit(1)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.cusSubmit(2)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("basicData.BulkImport"),
            visible: _vm.bulkImportDialog,
            width: "550px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.bulkImportDialog = $event
            },
            close: _vm.bulkImportClose,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-start",
                "align-items": "center",
                "margin-bottom": "10px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    color: "#00A551",
                    "font-size": "15px",
                    "margin-right": "20px",
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("collectionCenter.pleaseUploadByTemplate")
                      ) +
                      " "
                  ),
                  _c("br"),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: { click: _vm.downLoadFile },
                    },
                    [_vm._v(_vm._s(_vm.$t("basicData.DownloadTheTemplate")))]
                  ),
                ],
                1
              ),
              _c(
                "el-upload",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: {
                    "before-upload": _vm.beforeUpload,
                    "http-request": _vm.uploadFile,
                    "file-list": _vm.fileList,
                    "show-file-list": false,
                    "on-remove": _vm.handleRemove,
                    limit: 1,
                    action: "",
                  },
                },
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v(_vm._s(_vm.$t("collectionCenter.Upload"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.fileName
            ? _c("div", { staticClass: "downLink" }, [
                _c("div", [_vm._v(_vm._s(_vm.fileName))]),
                _c("div", [
                  _c("i", {
                    staticClass: "el-icon-error",
                    on: { click: _vm.delFile },
                  }),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-end",
                "align-items": "center",
              },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.fileSubmit(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.fileSubmit(2)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.confirm")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("customerManagements.versionHistory"),
            visible: _vm.versionHistoryDialog,
            width: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.versionHistoryDialog = $event
            },
            close: _vm.closeVersionHistoryDialog,
          },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.versionHistoryData,
                border: "",
                "max-height": "500",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "60",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "slaVersionDisplay",
                  label: _vm.$t("customerManagements.slaVersion"),
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: _vm.$t("customerManagements.snapshotTime"),
                  "min-width": "160",
                },
              }),
              _vm._l(_vm.historyTableHeaderList, function (item) {
                return _c("el-table-column", {
                  key: item.id,
                  attrs: {
                    label: item.label,
                    "min-width": item.cloWidth,
                    prop: item.prop,
                    "show-overflow-tooltip": false,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "merchantName" &&
                            scope.row.merchantName &&
                            scope.row.merchantCode
                              ? _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.merchantName) +
                                        "（" +
                                        _vm._s(scope.row.merchantCode) +
                                        "） "
                                    ),
                                  ]),
                                ])
                              : item.prop === "statusTypeObjName"
                              ? _c(
                                  "div",
                                  [
                                    scope.row.status === 0
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              size: "small",
                                              type: "danger",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.statusTypeObjName
                                              ) + " "
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              size: "small",
                                              type: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.statusTypeObjName
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                  ],
                                  1
                                )
                              : _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row[item.prop]
                                        ? "" + scope.row[item.prop]
                                        : "- -"
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createUserName",
                  label: _vm.$t("GlobalSetObj.CreatePeople"),
                  "min-width": "120",
                },
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }